export { default } from './pharmaprix-owners-footer.component';
